var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBxPediatrics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ac16733d-4916-49f4-b4fb-e6337292083c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "acc8305b-b498-4271-b1b1-7d1ad8126f98",
    "data-name": "Path 80",
    d: "M15.784,8.9a5.9,5.9,0,0,0-2.15-2.2,2.523,2.523,0,0,0,1.65-2.366.343.343,0,0,0-.686,0,1.835,1.835,0,0,1-1.834,1.834,1.367,1.367,0,0,1-.324-.039c-.081-.03-.164-.057-.247-.084a1.4,1.4,0,0,1-.828-1.276,1.053,1.053,0,0,1,1.05-1.05.772.772,0,0,1,.772.772.549.549,0,0,1-.549.549.372.372,0,0,1-.371-.371h0a.343.343,0,1,0-.686,0h0a1.057,1.057,0,0,0,1.053,1.057,1.235,1.235,0,0,0,1.234-1.234,1.459,1.459,0,0,0-1.457-1.458,1.739,1.739,0,0,0-1.736,1.736,2.075,2.075,0,0,0,.253,1,7.219,7.219,0,0,0-.918-.059A6.549,6.549,0,0,0,4.242,8.9a2.444,2.444,0,0,0,0,4.874,6.548,6.548,0,0,0,5.769,3.193,6.545,6.545,0,0,0,5.77-3.194,2.445,2.445,0,0,0,0-4.872m-.106,3.41a.8.8,0,0,1-.175-.02l-.6-.137-.238.569A4.963,4.963,0,0,1,10.016,15.5,4.962,4.962,0,0,1,5.36,12.717l-.242-.579-.61.148a.762.762,0,0,1-.185.022.98.98,0,0,1,0-1.947.762.762,0,0,1,.185.023l.61.148.242-.579a4.963,4.963,0,0,1,4.65-2.778A4.964,4.964,0,0,1,14.66,9.953l.238.569.6-.137a.8.8,0,0,1,.175-.02.978.978,0,0,1,0,1.944",
    style: {
      fill: "#005a7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b80e89e2-f053-4e76-af26-6146e8575e67",
    "data-name": "Path 81",
    d: "M8.861,11.052a.906.906,0,1,0-.906.906h0a.905.905,0,0,0,.906-.906",
    style: {
      fill: "#005a7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ea8b9ae8-ce16-4f58-9283-b0bc09448b1e",
    "data-name": "Path 82",
    d: "M12.071,10.146a.906.906,0,1,0,.906.906h0a.906.906,0,0,0-.906-.906",
    style: {
      fill: "#005a7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a2ae211f-0996-4d91-99b9-e4fca447ed74",
    "data-name": "Path 83",
    d: "M11.421,12.775a1.792,1.792,0,0,1-2.517.3,1.744,1.744,0,0,1-.3-.3.539.539,0,0,0-.815.7,2.869,2.869,0,0,0,4.035.413,2.78,2.78,0,0,0,.413-.413.539.539,0,0,0-.815-.7",
    style: {
      fill: "#005a7d"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxPediatrics);
export default __webpack_public_path__ + "static/media/bxPediatrics.6f4c2d74e27b82c97a6d68519369675c.svg";
export { ForwardRef as ReactComponent };